import { useGetClaimReceiptClaimIdGet } from "@/api-v3";

import { normalizeReceiptClaim } from "../helpers/normalize-claim";

import { PaymentFetchView } from "./payment-fetch-view";
import { useCancelableState } from "./use-cancelable-state";

interface ReceiptFetcherProps {
  id: string;
}

export const ReceiptFetcher = ({ id }: ReceiptFetcherProps) => {
  const { data, isLoading, error } = useGetClaimReceiptClaimIdGet(id);
  const cancel = useCancelableState("receipt", id);

  return (
    <PaymentFetchView
      isLoading={isLoading}
      error={error}
      view={data ? normalizeReceiptClaim(data) : null}
      cancel={cancel}
    />
  );
};
